<template>
  <v-card>
    <v-card-title>
      <span class="headline">Revisioner av "{{ item.name}}"</span>
    </v-card-title>

    <v-card flat class="px-2 pt-2">
      <v-data-table
        :headers="[
            { text: 'Status', value: 'state', sortable: false },
            { text: 'Rev', value: 'revision', sortable: false },
            { text: 'Oblig', value: 'required', sortable: false },
            { text: 'Nivå godk.', value: 'approvedLevel', sortable: false },
            { text: 'Nivå 1', value: 'textLvl1', sortable: false },
            { text: 'Nivå 2', value: 'textLvl2', sortable: false },
            { text: 'Nivå 3', value: 'textLvl3', sortable: false },
            { text: 'Nivå 4', value: 'textLvl4', sortable: false },            
          ]"
        :items="item.items"
        sort-by="date"
        sort-desc
        class="mb-4 "
        hide-default-footer
      >
        <!-- <template v-slot:item="{ item }">
        <tr v-bind:class="{'active-class-name': isActive(item)}">
    <td>Woo</td>
  </tr>
        </template>-->
        <template v-slot:item="{ item }">
          <tr v-bind:class="{'active': isActive(item)}">
            <td v-if="item.state==1">Aktuellt</td>
            <td v-else></td>
            <td>{{item.revision}}</td>
            <td v-if="item.required==true">JA</td>
            <td v-else>NEJ</td>

            <td>{{item.approvedLevel}}</td>
            <td>{{item.textLvl1}}</td>
            <td>{{item.textLvl2}}</td>
            <td>{{item.textLvl3}}</td>
            <td>{{item.textLvl4}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn  text @click="$emit('close')">Avbryt</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import findIndex from 'lodash/findIndex'
import find from 'lodash/find'
import filter from 'lodash/filter'
import omit from 'lodash/omit'
import maxBy from 'lodash/maxBy'

// @group Ebook
// Styled ProviderBookElementsRevModal component
export default {
  name: 'ProviderBookElementsRevModal',

  props: {
    //has item
    item: Object
  },

  data: () => ({}),

  watch: {},

  computed: {},

  created() {},

  methods: {
    isActive(item) {
      if(item.state==1)
      return true
      else
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.inline-flex {
  display: inline-flex !important;
}
</style>